<div class="background" (click)="close.emit()"></div>

<div class="wrapper dynamic" *ngIf="!static_selected" [style]="style">
	<button class="close" (click)="close.emit()">
		<i class="material-icons">close</i>
	</button>

	<div class="poster" *ngIf="html" [innerHTML]="html"></div>
</div>

@if( static_selected == 'paywall' ){
<div class="wrapper static-paywall" [style]="style">
	<button class="close" (click)="close.emit()">
		<i class="material-icons">close</i>
	</button>

	<h1>
		Only <b>Premium</b> Users!
	</h1>

	<h2>
		<a href="#" (click)="core.component_header.accounting_selection_shown=true">Click Here</a>
		<!--a href="https://account24network.com/" target="_blank">Click Here</a-->

		to purchase a&nbsp;<i>Premium&nbsp;Code</i>.
	</h2>

	<div class="features" *ngIf="html" [innerHTML]="html"></div>
	<div class="features" *ngIf="!html">
		<header>Premium features include:</header>

		<span>
			<i class="material-icons">hd</i>
			Max Quality support
		</span>

		<span>
			<i class="material-icons">apple</i>
			iOS / Mac OS /
			<i class="material-icons">android</i> Android Support
		</span>
		<span>
			<i class="material-icons">cast</i>
			Chromecast Support
		</span>

		<span>
			<i class="material-icons">workspace_premium</i>
			No Ads / No Blackouts
		</span>

		<small>
			Note: We currently do not provide replays of the current season after the 24h mark,<br/>
			We are currently working on this issue.
		</small>
	</div>
</div>
}
